import { ProductRecommendationLookup } from 'shared/types';

export const productRecommendations: ProductRecommendationLookup[] = [
  {
    uniqueid: '9611926499 | SERVICE KIT ACTUATOR U7000 | TFG NATIONAL',
    itemdescription: 'SERVICE KIT ACTUATOR U7000',
    itemid: '9611926499',
    lastpurchasedate: '3/17/2022',
    cost: '32.64',
    customertiersalesttm: '16789905.00',
    reason: 'Currently on Promotion',
    customername: 'TFG NATIONAL',
  },
  {
    uniqueid: 'RH500LAAA | RUST HANDLER - 0LAAA, 1/8IN CONN | TFG NATIONAL',
    itemdescription: 'RUST HANDLER - 0LAAA, 1/8IN CONN',
    itemid: 'RH500LAAA',
    lastpurchasedate: '',
    cost: '672.00',
    customertiersalesttm: '5678987.00',
    reason: 'High growth product for similar Tier III customers',
    customername: 'TFG NATIONAL',
  },
  {
    uniqueid: '13808 | ECO TBD 47IN, 12 3/4IN OD, 8 3/8IN ID | TFG NATIONAL',
    itemdescription: 'ECO TBD 47IN, 12 3/4IN OD, 8 3/8IN ID',
    itemid: '13808',
    lastpurchasedate: '7/14/2022',
    cost: '221.50',
    customertiersalesttm: '10567432.00',
    reason: 'High margin solution commonly sold to other Tier III customers',
    customername: 'TFG NATIONAL',
  },
  {
    uniqueid: '9611926499 | SERVICE KIT ACTUATOR U7000 | BAKER COMPANY',
    itemdescription: 'SERVICE KIT ACTUATOR U7000',
    itemid: '9611926499',
    lastpurchasedate: '3/17/2022',
    cost: '32.64',
    customertiersalesttm: '16789905.00',
    reason: 'Currently on Promotion',
    customername: 'BAKER COMPANY',
  },
  {
    uniqueid: 'RH500LAAA | RUST HANDLER - 0LAAA, 1/8IN CONN | BAKER COMPANY',
    itemdescription: 'RUST HANDLER - 0LAAA, 1/8IN CONN',
    itemid: 'RH500LAAA',
    lastpurchasedate: '',
    cost: '672.00',
    customertiersalesttm: '5678987.00',
    reason: 'High growth product for similar Tier II customers',
    customername: 'BAKER COMPANY',
  },
  {
    uniqueid: '7610-210SM2H402SRSTES5AN | 4IN CHANGEOVER VALVE | BAKER COMPANY',
    itemdescription: '4IN CHANGEOVER VALVE',
    itemid: '7610-210SM2H402SRSTES5AN',
    lastpurchasedate: '7/14/2022',
    cost: '4380.75',
    customertiersalesttm: '4567432.00',
    reason: 'Higher margin speciality solution',
    customername: 'BAKER COMPANY',
  },
];
